import Vue from 'vue';
import { config } from '_/config/config';
import { store } from '_/vuex/store';
const photonConfig = require('~/config/config.json');

const sessionChecker = {
    /**
     * Set session checker interval
     *
     * @return  {void}
     */
    setCheckerInterval() {
        Vue.http.options.root = config.ENV.apiBasePath;

        const url = 'auth/me';

        const method = 'get';

        const interval = photonConfig.sessionCheckerIntervalInSeconds * 1000;

        return setInterval(() => {
            const progressBarInterceptor = Vue.http.interceptors.pop();

            Vue.http[method](url)
                .then((response) => {
                    return response;
                })
                .catch((error) => {
                    if (error.data.message === 'TOKEN_INVALID') {
                        store.dispatch('ui/setShowSessionCheckerModal', true);
                    }

                    throw error;
                });

            Vue.http.interceptors.push(progressBarInterceptor);
        }, interval);
    },
};

export default sessionChecker;
